import { Check, User, Calendar } from 'lucide-react';
import StatusBadge from 'components/StatusBadge';
import { proceduresStatusHash } from './helper'
import { roleAbbreviations } from 'components/TreatmentPlan/helper'
import { startCase } from 'lodash';
import { formatDate } from 'utils/helpers';

const Procedures = ({ procedures }) => {
  return (
    <div>
      <div className="px-6 pt-5 pb-2">
        <h3 className="text-sm font-bold text-secondary-800">Procedures</h3>
      </div>

      <div className="px-6 space-y-3 max-h-[350px] overflow-y-auto">
        {procedures.map((procedure) => {
          let { title, provider, procedure_date, tx_status } = procedure.attributes || {}
          let { first_name, role } = provider?.data?.attributes || {}

          return (
            <div
              key={procedure.id}
              className="bg-slate-50 border border-slate-100/50 rounded-2xl p-4 flex flex-col gap-2 hover:bg-slate-100/40 transition-colors"
            >
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div
                    className={`flex items-center justify-center w-5 h-5 rounded-full border 
                    ${tx_status === 'completed' ?
                        'bg-green-500 border-green-500 text-white'
                        : 'border-green-500 text-green-600'
                      }`}
                  >
                    <Check size={12} strokeWidth={3} />
                  </div>

                  <span className="font-bold text-sm text-secondary-900 leading-none">{title}</span>
                </div>

                <StatusBadge
                  status={startCase(tx_status)}
                  className={proceduresStatusHash[tx_status]}
                />
              </div>

              <div className="flex gap-4 items-center text-xs text-secondary-500 mt-1">
                <div className="flex items-center gap-1.5">
                  <User size={13} className="text-secondary-400" />
                  <span>{`${roleAbbreviations[role]} ${first_name}`}</span>
                </div>

                {procedure_date &&
                  <div className="flex items-center gap-1.5">
                    <Calendar size={13} className="text-secondary-400" />
                    <span>{formatDate(procedure_date)}</span>
                  </div>
                }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Procedures
